import React from 'react'
import { cardStyles } from './styles'
import { Button } from '@nextui-org/button'
import PropTypes from 'prop-types'

const Card = ({ title, subtitle, buttonText, icon, navigate, path }) => {
  return (
    <div className={cardStyles.MAIN_CONTAINER}>
      <img src={icon} className="my-auto mx-auto h-[220px] w-[220px] object-contain" alt={title} />
      <div className="flex flex-col px-3 pb-6 space-y-3">
        <div className="text-center">
          <h1 className={cardStyles.TITLE}>{title}</h1>
          <p className="text-secondary">{subtitle}</p>
        </div>
        <div className={cardStyles.BUTTON_CONTAINER}>
          <Button
            type="submit"
            color="primary"
            size="lg"
            className="font-bold rounded-3xl"
            variant="shadow"
            onClick={() => navigate(path)}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

Card.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
  icon: PropTypes.string,
  navigate: PropTypes.func,
  path: PropTypes.string,
}

export default Card
